import { ColumnActionsMode, IChoiceGroupOption } from '@fluentui/react';
import moment from 'moment';

export const CUSTOMER = 'customer';
export const LOCATION = 'location';
export const BRAND = 'brand';
export const VEHICLE = 'vehicle';

export const TransferTireDetailsCols = [
  {
    key: 'column1',
    name: 'Prefix',
    fieldName: 'prefix',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column2',
    name: 'Brand #',
    fieldName: 'brandNo',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column3',
    name: 'Suffix',
    fieldName: 'suffix',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column4',
    name: 'Tire Size',
    fieldName: 'tireSize',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column5',
    name: 'Dispo Code',
    fieldName: 'dispCode',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column7',
    name: 'Status',
    fieldName: 'status',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column8',
    name: 'GLS Veh #',
    fieldName: 'vehicleNo',
    isSorted: true,
    isSortedDescending: false,
  },
  {
    key: 'column9',
    name: 'GLS Whl Pos',
    fieldName: 'glsWhlPos',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column10',
    name: 'Date of Last Change',
    fieldName: 'dateModified',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column11',
    name: 'Prev Veh #',
    fieldName: 'prevVehicleNo',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column12',
    name: 'Prev Whl Pos',
    fieldName: 'prevWheelPos',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column13',
    name: 'Miles',
    fieldName: 'totMiles',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column14',
    name: 'Comments',
    fieldName: 'comments',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column15',
    name: 'Images',
    fieldName: 'images',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
  {
    key: 'column16',
    name: 'Last Modified By',
    fieldName: 'lastModifiedBy',
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },
];

export const transferTo: IChoiceGroupOption[] = [
  { key: CUSTOMER, text: 'Other Customer' },
  { key: LOCATION, text: 'Other Location' },
];

export const selectBy: IChoiceGroupOption[] = [
  { key: BRAND, text: 'Brand Number' },
  { key: VEHICLE, text: 'Vehicle Number' },
];

export const emptyTransferTires = {
  relocateTires: false,
  newCustomerId: '',
  newLocationId: '',
  docDate: moment().format('MM/DD/YYYY'),
  docNum: '',
  fromBrand: {
    pfx: '',
    bno: '',
    sfx: null,
  },
  toBrand: {
    pfx: '',
    bno: '',
    sfx: null,
  },
  vehicleNumber: '',
};

export const mockTireData = [
  {
    prefix: 'ST',
    brandNumber: '12345',
    suffix: 'Z',
    tireSize: '202/31',
    inspectionCode: '20',
    dispCode: 'TR',
    noMatch: '0',
    status: 'Pending',
    vehicleNo: '000111',
    glsWhlPos: 'LRO',
    dateModified: '2024-11-08',
    prevVehicleNo: '1100',
    prevWheelPos: 'LLO',
    treadDepth: '12',
    billableTreadDepth: '10',
    images: '',
    lastModifiedBy: 'Jeanette',
  },
  {
    prefix: 'TS',
    brandNumber: '12345',
    suffix: 'Z',
    tireSize: '202/31',
    inspectionCode: '20',
    dispoCode: 'TR',
    noMatch: '0',
    status: 'Pending',
    glsVehNum: '000111',
    glsWhlPos: 'LRO',
    dateOfLastChange: '2024-11-08',
    previousVehicle: '1100',
    previousWhlPos: 'LLO',
    td: '12',
    billableTd: '10',
    images: '',
    lastModifiedBy: 'Jeanette',
  },
];

export const locationsColumns = [
  {
    key: 'column14',
    name: 'Ship To Number',
    fieldName: 'shipToNumber',
  },
  {
    key: 'column15',
    name: 'Location Code',
    fieldName: 'locationCode',
  },
  {
    key: 'column16',
    name: 'Address Line',
    fieldName: 'addrLine1',
  },
  {
    key: 'column17',
    name: 'City',
    fieldName: 'city',
  },
  {
    key: 'column18',
    name: 'State',
    fieldName: 'state',
  },
  {
    key: 'column19',
    name: 'Country',
    fieldName: 'country',
  },
  {
    key: 'column20',
    name: 'Available Status',
    fieldName: 'available',
  },
];